/**
 * Mirrors the backend guard behind CANNOT_DELETE_LAST_PAYMENT_METHOD
 * (`isLastRecurringMethod` in payment-method.utils.ts): a method cannot be removed
 * when it is the only chargeable one left.
 *
 * `chargeableTypes` is the product's `paymentMethodOnRecurringPayment` ∪
 * `paymentMethodOnBrokenMethod` — a fallback type is chargeable too, so it counts as
 * a way to be billed. An empty list means no type restriction, the same fallback the
 * backend applies (used for brokerage firms, which have no product config).
 */
export const isLastChargeableMethod = (
  methods: { id: string; status: string; paymentMethodType: string }[],
  targetId: string,
  chargeableTypes: string[],
): boolean => {
  const eligible = methods.filter(
    ({ status, paymentMethodType }) =>
      status === 'ACTIVE' &&
      (chargeableTypes.length === 0 || chargeableTypes.includes(paymentMethodType)),
  );

  return eligible.length === 1 && eligible[0]!.id === targetId;
};
